module.exports = __webpack_public_path__ + "img/06.f822118a.png";